export const customer_list = [
  {
    id:1,
    created: "22 Dec 2022",
    name: "Pratheesh Vayapurathu",
    phone_number: "+9876543210",
    email: "Pratheeshvayapurathu@gmail.com",
    city: "Banglore",
    service: "Fertility clinic",
    status: "In progress",
    last_contacted: "25 JAN 2023",
    time: "11:15",
    last_reminder: "Following Up",
  },

  {
    id:2,
    created: "24 Dec 2022",
    name: "Kanchanajoseh",
    phone_number: "+9876543210",
    email: "kanch@gmail.com",
    city: "chennai",
    service: "Mimo",
    status: "Not answered",
    last_contacted: "25 JAN 2023",
    time: "11:14",
    last_reminder: "Following Up",
  },
  {
    id:3,
    created: "21 Dec 2022",
    name: "Kanchanajoseph",
    phone_number: "+9876543210",
    email: "kanch@gmail.com",
    city: "chennai",
    service: "Needs action",
    status: "Not answered",
    last_contacted: "25 JAN 2023",
    time: "11:15",
    last_reminder: "Following Up",
  },
  {
    id:4,
    created: "22 Dec 2022",
    name: "Pratheesh Vayapurathu",
    phone_number: "+9876543210",
    email: "prath@gmail.com",
    city: "Banglore",
    service: "Fertility clinic",
    status: "In progress",
    last_contacted: "25 JAN 2023",
    time: "11:15",
    last_reminder: "Following Up",
  },

  {
    id:5,
    created: "24 Dec 2022", 
    name: "Kanchanajoseh",
    phone_number: "+9876543210",
    email: "kanch@gmail.com",
    city: "chennai",
    service: "Mimo",
    status: "Not answered",
    last_contacted: "25 JAN 2023",
    time: "11:14",
    last_reminder: "Following Up",
  },
  {
    id:6,
    created: "21 Dec 2022",
    name: "Kanchanajoseph",
    phone_number: "+9876543210",
    email: "kanch@gmail.com",
    city: "chennai",
    service: "Needs action",
    status: "Not answered",
    last_contacted: "25 JAN 2023",
    time: "11:15",
    last_reminder: "Following Up",
  },
  {
    id:7,
    created: "22 Dec 2022",
    name: "Pratheesh Vayapurathu",
    phone_number: "+9876543210",
    email: "prath@gmail.com",
    city: "Banglore",
    service: "Fertility clinic",
    status: "In progress",
    last_contacted: "25 JAN 2023",
    time: "11:15",
    last_reminder: "Following Up",
  },

  {
    id:8,
    created: "24 Dec 2022",
    name: "Kanchanajoseh",
    phone_number: "+9876543210",
    email: "kanch@gmail.com",
    city: "chennai",
    service: "Mimo",
    status: "Not answered",
    last_contacted: "25 JAN 2023",
    time: "11:14",
    last_reminder: "Following Up",
  },
  {
    id:5,
    created: "24 Dec 2022", 
    name: "Kanchanajoseh",
    phone_number: "+9876543210",
    email: "kanch@gmail.com",
    city: "chennai",
    service: "Mimo",
    status: "Not answered",
    last_contacted: "25 JAN 2023",
    time: "11:14",
    last_reminder: "Following Up",
  },
  {
    id:6,
    created: "21 Dec 2022",
    name: "Kanchanajoseph",
    phone_number: "+9876543210",
    email: "kanch@gmail.com",
    city: "chennai",
    service: "Needs action",
    status: "Not answered",
    last_contacted: "25 JAN 2023",
    time: "11:15",
    last_reminder: "Following Up",
  },
  {
    id:7,
    created: "22 Dec 2022",
    name: "Pratheesh Vayapurathu",
    phone_number: "+9876543210",
    email: "prath@gmail.com",
    city: "Banglore",
    service: "Fertility clinic",
    status: "In progress",
    last_contacted: "25 JAN 2023",
    time: "11:15",
    last_reminder: "Following Up",
  },

  {
    id:8,
    created: "24 Dec 2022",
    name: "Kanchanajoseh",
    phone_number: "+9876543210",
    email: "kanch@gmail.com",
    city: "chennai",
    service: "Mimo",
    status: "Not answered",
    last_contacted: "25 JAN 2023",
    time: "11:14",
    last_reminder: "Following Up",
  },
];

export const LogsList = [
  {
    date: "14 Jan 2023",
    time: "12:30 PM",
    medium: "1",
    status: "2",
    comments: "This patient has been onboarded",
  },
  {
    date: "14 Jan 2023",
    time: "12:30 PM",
    medium: "2",
    status: "3",
    comments: "This patient has been onboarded",
  },
  {
    date: "14 Jan 2023",
    time: "12:30 PM",
    medium: "3",
    status: "4",
    comments: "This patient has been onboarded",
  },
  {
    date: "14 Jan 2023",
    time: "12:30 PM",
    medium: "4",
    status: "1",
    comments: "This patient has been onboarded",
  },
  {
    date: "14 Jan 2023",
    time: "12:30 PM",
    medium: "1",
    status: "2",
    comments: "This patient has been onboarded",
  },
];
